import React from 'react'
import * as urls from 'legacy/common/urls'

export function renderUserName(user) {
  if (user.firstName && user.lastName) {
    return (
      <span>
        {user.firstName} <span>{user.lastName}</span>
      </span>
    )
  }

  return <span>{user.username}</span>
}

export function getFullName(user) {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`
  }

  return user.username
}

export function renderUserLink(user, className) {
  return (
    <a href={urls.publicProfile(user.username)} className={className}>
      {renderUserName(user)}
    </a>
  )
}
